export var dataProperties={privacyPolicy:'privacyPolicy'};export var privacyContentMaxLength=10000;